export default class UtilitiesService {
  /**
   * Used to create multi-part forms throughout the app
   */
  static createFormData(obj) {
    const formData = new FormData();

    Object.keys(obj).forEach(function (key) {
      formData.append(key, obj[key]);
    });

    return formData;
  }

  static fileReader(image) {
    return new Promise(function (resolve) {
      const fileReader = new FileReader();
      let imgSrc = null;
      fileReader.readAsDataURL(image);
      fileReader.onload = function () {
        imgSrc = fileReader.result;
        resolve(imgSrc);
      };
    });
  }

  static loadMore(flixels) {
    _.throttle(function () {
      if (flixels.numberOfDisplayed <= flixels.results.length) {
        flixels.numberOfDisplayed += 8;
      }
    }, 100);
  }

  /**
   * Django returns API errors as an object inside array. The key is the name of
   * the failed field. This method parses the error in cases where we don't know
   * what the failed field is.
   */

  static parseDjangoError(data) {
    if (!data) {
      return 'An error has occured.';
    }

    const errorField = Object.keys(data.response.data)[0];
    return data.response.data[errorField][0];
  }

  /**
   * Used to fix URL patterns that don't have http:// prefix.
   */
  static prefixHttp(url) {
    const pattern = /^((http|https|ftp):\/\/)/;
    const empty = url === '';
    if (!pattern.test(url) && !empty) {
      return 'http://' + url;
    }
    return url;
  }

  /**
   * Commong regex validators
   */

  static regAtMentions() {
    return /\B@[a-z0-9_-]+/gi;
  }

  static regMinPassword() {
    return /.{0,6}/;
  }

  static regUrlParse() {
    return /^(https?:\/\/)?([\dA-Za-z\.-]+)\.([A-Za-z\.]{2,6})([\/\w \.-]*)*\/?$/;
  }

  static regValidUsername() {
    return /^[a-zA-Z0-9\s\_]*$/;
  }
}



// WEBPACK FOOTER //
// ./src/services/utilities.es6.js